import React from "react";

const Delinquencies = () => {
  return (
    <div className="Delinquencies">
      <div className="dshbrd_acrdn">
        <ul className="adptn">
          <li>
            <span>1</span>
            <h2>0-30 DAYS</h2>
          </li>
          <li>
            <span>0</span>
            <h2>31-60 DAYS</h2>
          </li>
          <li>
            <span>0</span>
            <h2>61+ DAYS</h2>
          </li>
        </ul>

        <p className="alert alert-info">
        <i className="fa-solid fa-circle-exclamation"></i> You may have eligible debt that could be sent to collections.
          <a
            className="js-leasing-activity-income-verification-link"
            target="_blank"
            rel="noopener noreferrer"
            href="/"
          >
            See a list of eligible past tenants.
          </a>
        </p>
        <a href="/">View Debt Collections Status</a><br />
        <a href="/">View All Delinquencies</a>
      </div>
    </div>
  );
};

export default Delinquencies;
